import { Check, Sparkles } from 'lucide-react';
import { CtaLink, Eyebrow, OrbitalMotif } from '../shared/blocks';
import { BOSCO_FEATURES, BOSCO_WHY } from './homeContent';

function ChatPreview() {
  return (
    <div className="rounded-2xl border border-mk-edge bg-mk-midnight overflow-hidden" data-testid="bosco-chat-preview">
      <div className="flex items-center justify-between px-5 h-12 border-b border-mk-edge">
        <span className="flex items-center gap-2 text-sm font-semibold"><Sparkles className="h-4 w-4 text-mk-cyan" aria-hidden="true" /> Ask Bosco</span>
        <span className="text-[11px] text-slate-400">Example conversation</span>
      </div>
      <div className="p-5 space-y-4 text-sm">
        <p className="ml-auto max-w-[85%] w-fit rounded-2xl rounded-br-md bg-mk-blue px-4 py-2.5">Explain photosynthesis simply for Class 7.</p>
        <div className="max-w-[90%] rounded-2xl rounded-bl-md bg-mk-navy border border-mk-edge px-4 py-3 text-slate-200 leading-relaxed">
          Plants make their own food using sunlight.
          <ul className="mt-2 space-y-1 text-slate-300">
            <li>• Leaves take in carbon dioxide from the air</li>
            <li>• Roots bring up water</li>
            <li>• Chlorophyll uses sunlight to turn them into glucose and oxygen</li>
          </ul>
        </div>
        <p className="ml-auto max-w-[85%] w-fit rounded-2xl rounded-br-md bg-mk-blue px-4 py-2.5">Create 3 questions from this.</p>
        <div className="max-w-[90%] rounded-2xl rounded-bl-md bg-mk-navy border border-mk-edge px-4 py-3 text-slate-300 leading-relaxed">
          1. What do plants need for photosynthesis?<br />2. Which gas do plants release?<br />3. Why are leaves green?
        </div>
      </div>
      <div className="border-t border-mk-edge px-5 py-3 font-mono text-[12px] text-slate-400 overflow-x-auto whitespace-nowrap" data-testid="bosco-cli-preview">
        <span className="text-mk-cyan">bosco ❯</span> /lesson-plan quadratic equations --board cbse --class 10
      </div>
    </div>
  );
}

export function BoscoSection() {
  return (
    <section id="bosco-ai" className="relative overflow-hidden bg-mk-navy text-white py-20 sm:py-28 scroll-mt-16" data-testid="bosco-section">
      <div className="absolute inset-0 bg-[radial-gradient(45%_60%_at_15%_10%,rgba(32,217,242,0.14),transparent_60%)]" aria-hidden="true" />
      <OrbitalMotif className="-left-40 -bottom-48 h-[460px] w-[460px] hidden lg:block" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Eyebrow dark className="mb-5">Made for education</Eyebrow>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl leading-tight" data-testid="bosco-heading">
          Meet BOSCO AI. <span className="text-mk-cyan">Your Education-Focused AI Assistant.</span>
        </h2>
        <div className="mt-14 grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <ul className="space-y-6">
              {BOSCO_FEATURES.map(({ icon: Icon, title, text, badge }) => (
                <li key={title} className="flex gap-4" data-testid={`bosco-feature-${title.toLowerCase().replace(/\s/g, '-')}`}>
                  <span className="h-10 w-10 rounded-xl bg-mk-midnight border border-mk-edge grid place-items-center shrink-0"><Icon className="h-5 w-5 text-mk-cyan" aria-hidden="true" /></span>
                  <div>
                    <h3 className="font-semibold text-base flex flex-wrap items-center gap-2">
                      {title}
                      {badge && <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border border-mk-cyan/40 text-mk-cyan">{badge}</span>}
                    </h3>
                    <p className="mt-1 text-sm text-slate-300 leading-relaxed">{text}</p>
                  </div>
                </li>
              ))}
            </ul>
            <div className="mt-10 rounded-2xl border border-mk-edge p-5" data-testid="bosco-why">
              <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-mk-cyan">Why “Made for Education”</h3>
              <ul className="mt-3 grid sm:grid-cols-3 gap-3">
                {BOSCO_WHY.map((w) => (
                  <li key={w} className="flex items-start gap-2 text-sm text-slate-200"><Check className="h-4 w-4 mt-0.5 text-mk-cyan shrink-0" aria-hidden="true" />{w}</li>
                ))}
              </ul>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <CtaLink to="/bosco-studio" variant="light" arrow testid="bosco-cta-studio">Open BOSCO Studio</CtaLink>
              <CtaLink to="/signup" variant="ghostDark" testid="bosco-cta-signup">Try BOSCO free</CtaLink>
            </div>
          </div>
          <ChatPreview />
        </div>
      </div>
    </section>
  );
}
